import { Button, Image } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const SkuInfoWrapper = styled.div`
  align-items: center;
  background: var(--color-bg-weaker);
  border-radius: var(--size-border-radius-sm);
  display: flex;
  flex-direction: row;
  gap: var(--size-gap-2);
  padding: var(--size-gap-2) var(--size-gap-4);
`;

const ProductImageWrapper = styled.figure`
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  min-width: 80px;
  overflow: hidden;
  width: 80px;

  ${Image.S.Image} {
    object-fit: contain;
  }
`;

const HorizontalProductWrapper = styled.div`
  display: flex;
  position: relative;
`;

const ProductDescription = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
  padding: 0 16px 0 0;
  width: 171px;
`;

const ProductActions = styled.div`
  display: flex;
  flex-direction: column;

  ${Button.S.Button} {
    align-items: center;
    background: var(--color-bg-body);
    border-radius: var(--size-border-radius-circle); //
    display: flex;
    height: 24px;
    justify-content: center;
    width: 24px;
  }
`;

const ProductPriceWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 300px;
`;

const EditButton = styled(Button)`
  background: none;
  cursor: pointer;
`;

export {
  EditButton,
  HorizontalProductWrapper,
  ProductActions,
  ProductDescription,
  ProductImageWrapper,
  ProductPriceWrapper,
  SkuInfoWrapper,
  Wrapper
};
